<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" (click)="onBackToAuthCr()"><img src="assets/images/admin/backarrow.png" /> Back to course Management</a>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png"/> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<ngx-spinner>
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<div class="centerWrap mt-4 pt-2">
    
    <div class="formHeading pr-0">
        <div class="row m-0">
            <div class="col-12 col-md-4">
        <h2>Add Content Capsule</h2>
        <p>Please select a capsule to attach to a submodule</p>
    </div>
    <div class="col-12 col-md-4">
        <div class="filterWrap">
            <div class="searchWrap mr-0">
                <input type="text" placeholder="Search Capsule Name" (keyup)="search($event)">
            </div>
        </div>
    </div>
  
        </div>
    </div>
    <div class="tableWrap">
        <table  matSort (matSortChange)="sortData($event)">
            <thead>
                <tr>
                    <th width="40">&nbsp;</th>
                    <th><div mat-sort-header="capsule_name"><b></b> Content Capsule Name</div></th>
                    <th>Capsule Type</th>
                    <th></th> 
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let values of capsuleData" >
                    <td>
                        <div class="customCheck">
                            <mat-radio-button [value]="values.content_capsule_id" (change)="radioChange($event)"></mat-radio-button>
                        </div>
                    </td>
                    <td>
                        <div class="userTdWrap">
                            <a href="javascript:void(0);" class="btn-link d-block">{{values.capsule_name}}</a>
                            <b>Created on {{values.created_dttm}}</b>
                        </div>
                    </td>
                    <td>
                        <ul class="modifyIcons">
                            <li *ngIf="values.assessment_id"><a href="javascript:void(0);" ><img src="assets/images/icons/frame.svg"></a></li>
                            <li  *ngIf="values.media_type_list[0]==1"><a href="javascript:void(0);"><img src="assets/images/icons/text.svg"></a></li>
                            <li  *ngIf="values.media_type_list[0]==2"><a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg"></a></li>
                            <li  *ngIf="values.media_type_list[0]==3"><a href="javascript:void(0);"><img src="assets/images/icons/text.svg"></a></li>

                            <li  *ngIf="values.media_type_list[1]==1"><a href="javascript:void(0);"><img src="assets/images/icons/text.svg"></a></li>
                            <li  *ngIf="values.media_type_list[1]==2"><a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg"></a></li>
                            <li  *ngIf="values.media_type_list[1]==3"><a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg"></a></li>

                            <li  *ngIf="values.media_type_list[2]==1"><a href="javascript:void(0);"><img src="assets/images/icons/text.svg"></a></li>
                            <li  *ngIf="values.media_type_list[2]==2"><a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg"></a></li>
                            <li  *ngIf="values.media_type_list[2]==3"><a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg"></a></li>
                            
                        </ul>
                    </td>
                    <td>
                        <ul class="userActionBtn justify-content-start">
                            <li>
                                <!-- <a href="javascript:void(0);" class="btn-link text-uppercase"[routerLink]="['/authoring_viewContent']"
                                [queryParams]="{id:values.content_capsule_id}">View Capsule Content</a> -->
                                <!-- <a href="javascript:void(0);" class="btn-link text-uppercase">View Capsule Content</a> -->
                            </li>
                    </ul>
                    </td>
                 </tr>
                
            
             </tbody>
        </table>

        <div class="text-center">
            <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)=open(cancelModle)>Cancel</a>
            <a href="javascript:void(0);" class="btn btn-primary btn-sm" [ngClass]="copsuleId == ''? 
            'btn btn-primary btn-sm btn-border ml-1 mr-1 disableborder ' : 'btn btn-primary btn-sm '" (click)="assignCapsule()"
            >Assign capsule to submodule</a>
        </div>
    </div>
</div>
<ng-template #cancelModle let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Cancel Content Capsule</h6>
                <p class="size18">Are you sure you would like to Cancel this Content Capsule?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="cancelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">Cancel</a>
                <a href="javascript:void(0);" (click)="onBackToAuthCr()" class="btn btn-primary btn-sm">Confirm</a>
            </div>
        </div>
    </div>
</ng-template>
<!-- <app-view-capsule *ngIf="" (finalViewCap)="backFromAss($event)"
    [capsuleData]="capsuleData_id"></app-view-capsule> -->
